import { styled } from '../../../stitches.config';

export const Row = styled('li', {
  'display': 'flex',
  'alignItems': 'center',
  'position': 'relative',
  'listStyleType': 'none',
  'marginBottom': '$3',
  'gap': '$3',
  '&:last-child': {
    marginBottom: '0',
  },
  '&::before': {
    content: '',
    position: 'absolute',
    borderTopWidth: '2px',
    borderTopStyle: 'solid',
    width: 'calc(4 * $1)',
    height: 'calc(50% + 2px / 2 + $1)',
    top: 'calc(50% - 2px / 2)',
    left: 'calc(-4 * $1)',
  },
  '.&:lastChild::before': {
    borderLeft: 0,
  },
});
